// Import from the leaf modules, not the `@/api` barrel. The barrel sits in an
// import cycle (api/index -> entry.js -> ErrorBoundary -> errors.actions ->
// api/index); under eager ESM evaluation (vite/vitest) that left the barrel's
// re-exported `apiService` undefined when this module was evaluated mid-cycle,
// so `apiService.core` below threw. `./apiService` is cycle-free, so importing
// it directly guarantees it's defined at eval time. (`./fetchingAPI` still
// transitively imports entry.js, but it's only *called* at runtime — inside
// postError — never at module eval, so its own cycle is harmless here.)
import { fetchingAPI } from '../../api/fetchingAPI'
import { apiService } from '../../api/apiService'

export const postError = (errorInfo) => (dispatch) => {
  fetchingAPI(`${apiService.core}/api/errors`, 'POST', dispatch, JSON.stringify(errorInfo))
    .then(() => console.info('Error logged'))
    .catch(() => console.error('Unable to post error to server.'))
}
